module.exports = __webpack_public_path__ + "static/img/qywx-details.a289da6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/qywx-details.png
// module id = 89UG
// module chunks = 0